module.exports = "/assets/6d790ed69fc503ebf7b7ea918517feff.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/B0.png
// module id = 1214
// module chunks = 0